import * as React from "react";
import Paper from "@mui/material/Paper";
import { useEffect, useState } from "react";
import {
   Autocomplete,
   Box,
   Divider,
   FormControl,
   FormControlLabel,
   FormLabel,
   IconButton,
   InputAdornment,
   List,
   ListItem,
   ListItemText,
   Modal,
   Radio,
   RadioGroup,
   Stack,
   SwipeableDrawer,
   TextField,
   Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import api from "../../../utils/Url";
import { useLocation } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { GridColDef } from "@mui/x-data-grid";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import DeleteIcon from "@mui/icons-material/Delete";
import { getId, getISTDate } from "../../../utils/Constant";
import CustomDataGrid from "../../../utils/CustomDatagrid";
import CustomLabel from "../../../CustomLable";
import ButtonWithLoader from "../../../utils/ButtonWithLoader";
import Languages from "../../../Languages";
import { Language } from "react-transliterate";
import "react-transliterate/dist/index.css";
import TranslateTextField from "../../../TranslateTextField";
import {
   GoogleMap,
   InfoWindow,
   LoadScript,
   Marker,
} from "@react-google-maps/api";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import DataGrids from "../../../utils/Datagrids";
import VisibilityIcon from '@mui/icons-material/Visibility';
import RosterComponent from "../../../utils/RosterComponent";
import ReactQuill from "react-quill";
import InfoIcon from '@mui/icons-material/Info';




const containerStyle = {
   width: "100%",
   height: "450px",
};

const style = {
   position: "absolute" as "absolute",
   top: "50%",
   left: "50%",
   transform: "translate(-50%, -50%)",
   width: "180vh",
   height: "85vh",
   bgcolor: "#f5f5f5",
   border: "1px solid #000",
   boxShadow: 24,
   p: 4,
   borderRadius: 10,
};




interface MenuPermission {
   isAdd: boolean;
   isEdit: boolean;
   isPrint: boolean;
   isDel: boolean;
}

export default function ComplainAssignMaster() {
   const { i18n, t } = useTranslation();
   const { defaultValues, defaultValuestime } = getISTDate();
   const [columns, setColumns] = useState<any>([]);
   const [rows, setRows] = useState<any>([]);
   const location = useLocation();
   const [isLoading, setIsLoading] = useState(true);
   const [toaster, setToaster] = useState(false);
   const [timerCheck, setTimerCheck] = useState<NodeJS.Timeout | null>(null);

   const [permissionData, setPermissionData] = useState<MenuPermission>({
      isAdd: false,
      isEdit: false,
      isPrint: false,
      isDel: false,
   });
   const [lang, setLang] = useState<Language>("en");

   const [empName, setEmpName] = useState("");
   const [complain, setComplain] = useState("");

   const [viewData, setViewData] = useState<any>([]);
   const [isShow, setShow] = useState(false);

   const [empData, setEmpData] = useState([
      { empId: -1, label: t("text.EmpName") },
   ]);

   const [compData, setCompData] = useState([
      { value: -1, label: t("text.SelectComplainNo") },
   ]);

   const [rosterData, setRosterData] = useState([
      { value: -1, label: t("text.SelectRoster") },
   ]);


   const [IsStatus, setStatus] = useState([
      { value: -1, label: t("text.ComplainStatus") },
   ]);


   const [IsItem, setItem] = useState([
      { value: -1, label: t("text.SelectItem") },
   ]);

   const [showItem, setShowItem] = useState(false);

   const ItemSt = [
      { label: "Replace", value: 1 },
      { label: "Repair", value: 2 }
   ]


   const Userid = getId();


   const [editId, setEditId] = useState(0);

   const [IsShow1, setShow1] = useState(false);




   const [vehicles, setVehicles] = useState<any>([]);
   const [activeVehicle, setActiveVehicle] = useState<any>(null);
   const [center, setCenter] = useState({ lat: 26.447965, lng: 80.3432 });
   const mapRef: any = React.useRef(null);
   const [currentMap, setCurrentMap] = useState(false);

   // Fetch the vehicle data from API
   const MapData = async (Id: any) => {
      setCurrentMap(true);

      const result = await api.post(`ComplainAssign/GetComplainAssign`, {
         "id": Id,
         "complainId": -1,
         "empId": -1
      });
      const validItems = result?.data?.data;

      console.log("validItems", validItems);
      const arr = validItems.map((item: any, index: any) => ({
         lat: parseFloat(item?.latitude),
         lng: parseFloat(item?.longitude),
         id: index + 1,
         zone: item?.zoneName,
         empName: item?.empName,

         ward: item.wardName,
         assignDate: item?.assignDate,
         poleNo: item.poleNo,

         icon: "https://cdn-icons-png.flaticon.com/512/209/209403.png",
      }));
      setVehicles(arr);
      setCenter(calculateCenter(arr));

      if (arr.length > 0) {
         adjustZoomLevel(arr);
      }
   };

   const calculateCenter = (vehicles: any) => {
      if (vehicles.length === 0) {
         return { lat: 26.447965, lng: 80.3432 }; // Default center if no vehicles
      }

      const latitudes = vehicles.map((vehicle: any) => vehicle.lat);
      const longitudes = vehicles.map((vehicle: any) => vehicle.lng);

      const avgLat =
         latitudes.reduce((sum: any, lat: any) => sum + lat, 0) / latitudes.length;
      const avgLng =
         longitudes.reduce((sum: any, lng: any) => sum + lng, 0) /
         longitudes.length;

      return { lat: avgLat, lng: avgLng }; // Return the center point
   };

   // Adjust the zoom level based on the spread of the vehicles
   const adjustZoomLevel = (vehicles: any) => {
      const bounds = new window.google.maps.LatLngBounds();

      vehicles.forEach((vehicle: any) => {
         bounds.extend(new window.google.maps.LatLng(vehicle.lat, vehicle.lng));
      });

      if (mapRef.current) {
         mapRef.current.fitBounds(bounds); // Fit the map to the bounds of all vehicles
      }
   };

   const handleMarkerMouseOver = (vehicle: any) => {
      setActiveVehicle(vehicle);
   };

   const handleMarkerMouseOut = () => {
      setActiveVehicle(null);
   };


   useEffect(() => {
      getComplaintData();
      getEmpData();
      getRosterData();
      getStatusData();
      getItemData();

      //getList();
      const timeoutId = setTimeout(() => {
         getList();
      }, 100);
      return () => clearTimeout(timeoutId);
   }, [isLoading]);


   const getViewData = async () => {
      const collectData = {
         "rosGroupId": formik.values.rosterGroupID || 0,

      };
      const response = await api.post(`RosterGroup/GetRosterGroup`, collectData);
      const data = response.data.data || [];
      if (data) {


         setViewData(data);
         setShow(true);
      }
   }



   const getItemData = async () => {
      const collectData = {
         "itemMasterId": -1,

      };
      const response = await api.post(`ItemMaster/GetItemMaster`, collectData);
      const data = response.data.data;
      //console.log("getComplaintData", data);
      const arr = [];
      for (let index = 0; index < data.length; index++) {
         arr.push({
            value: data[index]["itemMasterId"],
            label: data[index]["itemName"],
         });
      }
      setItem(arr);
   }



   const getRosterData = async () => {
      const collectData = {
         "rosGroupId": -1,

      };
      const response = await api.post(`RosterGroup/GetRosterGroup`, collectData);
      const data = response.data.data;
      //console.log("getComplaintData", data);
      const arr = [];
      for (let index = 0; index < data.length; index++) {
         arr.push({
            value: data[index]["rosGroupId"] || 0,
            label: data[index]["groupName"]  || "_ _",
         });
      }
      setRosterData(arr);
   }


   const getEmpData = async () => {
      const collectData = {
         "empid": -1,
         "userId": "",
         "empName": "",
         "empMobileNo": "",
         "empDesignationId": 0,
         "empDeptId": 0,
         "empStateId": 0,
         "empCountryID": 0,
         "empCityId": 0,
         "empPincode": 0,
         "roleId": ""
      };
      const response = await api.post(`EmpMaster/GetEmpmaster`, collectData);
      const data = response.data.data;
      const arr = [];
      for (let index = 0; index < data.length; index++) {
         arr.push({
            empId: data[index]["empid"],
            label: data[index]["empName"],
         });
      }
      setEmpData(arr);
   }

   const getComplaintData = async () => {
      const collectData = {
         "compId": -1,
         "empId": -1,
         "zoneid": -1,
         "wardid": -1,
         "compTypeId": -1,
         "compStatusId": -1,
         "complaintNo": "",
         "fromDate": null,
         "toDate": null,
         "show": true,
         "exportOption": ".pdf"
      };
      const response = await api.post(`ComplaintItem/GetComplaintItem`, collectData);
      const data = response.data.data;
      console.log("getComplaintData", data);
      const arr = [];
      for (let index = 0; index < data.length; index++) {
         arr.push({
            value: data[index]["compId"] || 0,
            label: data[index]["complaintNo"] || "",
            complaint: data[index]["complaint"] || "",
         });
      }
      setCompData(arr);
   }



   const getStatusData = async () => {
      const collectData = {
         "id": -1,

      };
      const response = await api.post(`statusmaster/GetStatusMaster`, collectData);
      const data = response.data.data;
      // console.log("getComplaintData", data);
      const arr = [];
      for (let index = 0; index < data.length; index++) {
         arr.push({
            value: data[index]["id"],
            label: data[index]["status"],
         });
      }
      setStatus(arr);
   }



   let delete_id = "";
   const accept = () => {
      const collectData = {
         "id": delete_id
      }
      console.log("collectData " + JSON.stringify(collectData));
      api
         .post(`ComplainAssign/DeleteComplainAssign`, collectData)
         .then((response) => {
            if (response.data.isSuccess) {
               toast.success(response.data.mesg);
            } else {
               toast.success(response.data.mesg);
            }
            getList();
         });
   };
   const reject = () => {
      toast.warn("Rejected: You have rejected", { autoClose: 3000 });
   };

   const handledeleteClick = (del_id: any) => {
      console.log(del_id + " del_id ");
      delete_id = del_id;
      confirmDialog({
         message: "Do you want to delete this record ?",
         header: "Delete Confirmation",
         icon: "pi pi-info-circle",
         acceptClassName: "p=-button-danger",
         accept,
         reject,
      });
   };

   function formatDate(dateString: string) {
      const timestamp = Date.parse(dateString);
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
   }


   const getList = () => {
      const collectData = {
         "id": -1,
         "complainId": -1,
         "empId": -1,
         "show": true,
         "exportOption": ".pdf"
      };
      try {
         api
            .post(`ComplainAssign/GetComplainAssign`, collectData)
            .then((res) => {
               //console.log("result" + JSON.stringify(res.data.data));
               const data = res.data.data;
               const arr = data.map((item: any, index: any) => ({
                  ...item,
                  serialNo: index + 1,
                  id: item.id,
                  complainId: item.complainId,
                  //complainName:item.complainName,
                  complainName: compData[compData.findIndex(i => i.value === item.complainId)]?.label,
                  source: item?.inHouse === true ? "In House" : "Out Source"
               }));
               setRows(arr);
               setIsLoading(false);
               if (data.length > 0) {
                  const columns: GridColDef[] = [
                     {
                        field: "actions",
                        headerClassName: "MuiDataGrid-colCell",
                        headerName: t("text.Action"),
                        width: 150,

                        renderCell: (params) => {
                           return [
                              <Stack
                                 spacing={1}
                                 direction="row"
                                 sx={{ alignItems: "center", marginTop: "5px" }}
                              >
                                 <EditIcon
                                    style={{
                                       fontSize: "20px",
                                       color: "blue",
                                       cursor: "pointer",
                                    }}
                                    className="cursor-pointer"
                                    onClick={() => routeChangeEdit(params.row)}
                                 />
                                 <DeleteIcon
                                    style={{
                                       fontSize: "20px",
                                       color: "red",
                                       cursor: "pointer",
                                    }}
                                    onClick={() => {
                                       handledeleteClick(params.row.id);
                                    }}
                                 />
                              </Stack>,
                           ];
                        },
                     },

                     {
                        field: "assignDate",
                        headerName: t("text.ComplainDate"),
                        flex: 1,
                        headerClassName: "MuiDataGrid-colCell",
                     },
                     {
                        field: "empName",
                        headerName: t("text.EmpName"),
                        flex: 1,
                        headerClassName: "MuiDataGrid-colCell",
                     },
                     {
                        field: "complainName",
                        headerName: t("text.Complain"),
                        flex: 1,
                        headerClassName: "MuiDataGrid-colCell",
                     },

                     {
                        field: "statusName",
                        headerName: t("text.Status"),
                        flex: 1,
                        headerClassName: "MuiDataGrid-colCell",
                     },
                     {
                        field: "source",
                        headerName: t("text.Source"),
                        flex: 1,
            
                        headerClassName: "MuiDataGrid-colCell",
                      },


                     {
                        field: "map",
                        headerName: t("text.Map"),
                        flex: 1,
                        headerClassName: "MuiDataGrid-colCell",
                        renderCell: (params) => {
                           return [
                              <Stack
                                 spacing={1}
                                 direction="row"
                                 sx={{ alignItems: "center", marginTop: "5px" }}
                              >
                                 <LocationOnIcon
                                    style={{
                                       fontSize: "20px",
                                       color: "#65b7c9",
                                       cursor: "pointer",
                                    }}
                                    onClick={() => {
                                       MapData(params.row.id);
                                    }}
                                 />
                              </Stack>,
                           ];
                        },
                     },
                  ];
                  setColumns(columns as any);
               }
            });
         // setIsLoading(false);
      } catch (error) {
         console.error("Error fetching data:", error);
         // setIsLoading(false);
      }
   };


   const formik = useFormik({
      initialValues: {
         "id": 0,
         // "zoneID": 0,
         // "wardID": 0,
         "assignDate": new Date().toISOString().slice(0, 10) || "",
         "complainId": 0,
         "empId": 0,
         "createdBy": Userid,
         "updatedBy": "",
         "createdOn": defaultValuestime,
         "updatedOn": defaultValuestime,
         "complainName": "",
         "empName": "",
         "inHouse": true,
         "outSource": true,
         rosterGroupID: 0,
         rosterGroupName: "",
         isEmp: true,
         isRoaster: false,
         "poleNo": 0,
         "latitude": "",
         "longitude": "",
         "zone": 0,
         "ward": 0,
         "itemStatus": "",
         "statusId": 3,
         "statusName": "Processing",
         itemStatusId: 0,
         "itemIId": 0,
         "itemIName": "",
         "complainNo": "",
         remark: "",
      },
      validationSchema: Yup.object({
         assignDate: Yup.string()
            .required(t("text.reqAssignDate")),
         // empName: Yup.string()
         //    .required(t("text.reqEmpName")),
         complainName: Yup.string()
            .required(t("text.reqComplain")),
      }),
      onSubmit: async (values) => {
         const response = await api.post(
            `ComplainAssign/AddUpdateComplainAssign`,
            values
         );
         if (response.data.isSuccess) {
            setToaster(false);
            toast.success(response.data.mesg);
            formik.resetForm();
            setEmpName("");
            setComplain("");
            getList();
            setEditId(0);
            setShowItem(false)
         } else {
            setToaster(true);
            toast.error(response.data.mesg);
         }

      },
   });

   const requiredFields = ["departmentName"];


   const routeChangeEdit = (row: any) => {
      //console.log("row", compData.findIndex(i => i.value === row.complainId));
      formik.setFieldValue("id", row.id);
      formik.setFieldValue("assignDate", formatDate(row.assignDate));
      formik.setFieldValue("empId", row.empId);
      formik.setFieldValue("complainId", row.complainId);
      formik.setFieldValue("empName", row.empName);
      formik.setFieldValue("complainName", row.complainName);
      formik.setFieldValue("rosterGroupID", row.rosterGroupID);
      formik.setFieldValue("inHouse", row.inHouse);
      formik.setFieldValue("outSource", row.outSource);
      formik.setFieldValue("isEmp", row.isEmp);
      formik.setFieldValue("isRoaster", row.isRoaster);
      setEditId(row.id);
      formik.setFieldValue("statusId", row.statusId);
      formik.setFieldValue("statusName", row.statusName);
      formik.setFieldValue("itemStatusId", row.itemStatusId);
      formik.setFieldValue("itemStatus", row.itemStatus);
      formik.setFieldValue("itemIId", row.itemIId);
      formik.setFieldValue("itemIName", row.itemIName);

      formik.setFieldValue("complainNo", row.complainNo);
      formik.setFieldValue("remark", row.remark);

      formik.setFieldValue("createdBy", "");
      formik.setFieldValue("updatedBy", Userid);

      if (row.statusId === 2) {
         setShow1(true);
      } else if (row.statusId === 3) {
         setShow1(true);
      } else {
         setShow1(false);
      }



      if (row.itemStatusId === 1) {
         setShowItem(true);
      } else {
         setShowItem(false);
      }




      setEmpName(row.empName);
      compData.map((i) => {
         if (i.value === row.complainId) {
            setComplain(i.label || "");
         }
      })
   };


   const handleSubmitWrapper = async () => {
      await formik.handleSubmit();
   };

   const handleConversionChange = (params: any, text: string) => {
      formik.setFieldValue(params, text);
   };


   return (
      <>
         <Grid item lg={6} sm={6} xs={12} sx={{ marginTop: "3vh" }}>
            <Card
               style={{
                  width: "100%",
                  height: "50%",
                  backgroundColor: "#E9FDEE",
                  border: ".5px solid #2B4593 ",
                  marginTop: "5px",
               }}
            >
               <Paper
                  sx={{
                     width: "100%",
                     overflow: "hidden"
                  }}
                  style={{ padding: "10px" }}
               >
                  <ConfirmDialog />

                  <Grid item xs={12} container spacing={2}>
                     <Grid item lg={10} md={10} xs={12}>
                        <Typography
                           gutterBottom
                           variant="h5"
                           component="div"
                           sx={{ padding: "20px" }}
                           align="left"
                        >
                           {t("text.AssignComplain")}
                        </Typography>
                     </Grid>

                     <Grid item lg={2} md={2} xs={12} marginTop={2}>
                        <select
                           className="language-dropdown"
                           value={lang}
                           onChange={(e) => setLang(e.target.value as Language)}
                        >
                           {Languages.map((l) => (
                              <option key={l.value} value={l.value}>
                                 {l.label}
                              </option>
                           ))}
                        </select>
                     </Grid>
                  </Grid>
                  <Divider />

                  <Box height={10} />

                  <form onSubmit={formik.handleSubmit}>
                     <Grid item xs={12} container spacing={2}>
                        <Grid item md={4} sm={4} xs={12}>
                           <TextField
                              label={
                                 <CustomLabel
                                    text={t("text.ComplainDate")}
                                    required={true}
                                 />
                              }
                              type="date"
                              variant="outlined"
                              fullWidth
                              size="small"
                              name="assignDate"
                              id="assignDate"
                              value={formik.values.assignDate}
                              placeholder={t("text.ComplainDate")}
                              onChange={formik.handleChange}
                              InputLabelProps={{ shrink: true }}
                           />
                           {formik.touched.assignDate && formik.errors.assignDate ? (
                              <div style={{ color: "red", margin: "5px" }}>
                                 {formik.errors.assignDate}
                              </div>
                           ) : null}
                        </Grid>


                        {formik.values.isEmp && (
                           <Grid item md={4} sm={4} xs={12}>
                              <Autocomplete
                                 disablePortal
                                 id="combo-box-demo"
                                 options={empData}
                                 value={empName}
                                 fullWidth
                                 size="small"
                                 onChange={(event: any, newValue: any) => {
                                    console.log(newValue);
                                    formik.setFieldValue("empName", newValue?.label);
                                    formik.setFieldValue("empId", newValue?.empId);
                                    setEmpName(newValue?.label);
                                 }}
                                 renderInput={(params) => (
                                    <TextField
                                       {...params}
                                       label={<CustomLabel text={t("text.ComplainAssignTo")} required={true} />}
                                       name="empName"
                                       id="empName"
                                       placeholder={t("text.EmpName")}
                                       error={formik.touched.empName && Boolean(formik.errors.empName)}
                                    />
                                 )}
                              />
                              {formik.touched.empName && formik.errors.empName ? (
                                 <div style={{ color: "red", margin: "5px" }}>
                                    {formik.errors.empName}
                                 </div>
                              ) : null}
                           </Grid>

                        )}


                        {formik.values.isRoaster && (

                           <Grid item md={4} sm={4} xs={12}>
                              <Autocomplete
                                 disablePortal
                                 id="combo-box-demo"
                                 options={rosterData}
                                 value={rosterData.find((opt: any) => opt.value === formik.values.rosterGroupID) || null}
                                 fullWidth

                                 size="small"
                                 onChange={(event: any, newValue: any) => {
                                    console.log(newValue);
                                    // formik.setFieldValue("roasterGroup", newValue?.label.toString());
                                    formik.setFieldValue("rosterGroupID", parseInt(newValue?.value));
                                    //setComplain(newValue.label);
                                 }}
                                 renderInput={(params) => (
                                    <TextField
                                       {...params}
                                       label={<CustomLabel text={t("text.ComplainAssignTo")} required={false} />}
                                       placeholder={t("text.SelectRoster")}

                                       InputProps={{
                                          ...params.InputProps,
                                          endAdornment: (
                                             <InputAdornment position="end">
                                                <IconButton onClick={() => getViewData()}>
                                                   <InfoIcon sx={{ width: 24, height: 24, fontSize: '30px', marginLeft: '8px', color: "#2cafc9" }} />
                                                </IconButton>
                                             </InputAdornment>
                                          ),
                                       }}


                                    />
                                 )}
                              />

                           </Grid>

                        )}

                        <Grid item md={4} sm={4} xs={12}>
                           <Autocomplete
                              disablePortal
                              id="combo-box-demo"
                              options={compData}
                              value={complain}
                              fullWidth
                              size="small"
                              onChange={(event: any, newValue: any) => {
                                 if (newValue) {
                                    console.log(newValue);
                                    formik.setFieldValue("complainNo", newValue?.label.toString() || "");
                                    formik.setFieldValue("complainId", parseInt(newValue?.value) || 0);
                                    formik.setFieldValue("complainName", newValue?.complaint.toString() || "");
                                    setComplain(newValue.label || "");
                                 } else {
                                    // Handle case where the selection is cleared (newValue is null)
                                    formik.setFieldValue("complainNo", "");
                                    formik.setFieldValue("complainId", 0);
                                    formik.setFieldValue("complainName", "");
                                    setComplain("");
                                 }
                              }}
                              renderInput={(params) => (
                                 <TextField
                                    {...params}
                                    label={<CustomLabel text={t("text.SelectComplainNo")} required={true} />}
                                    name="complainNo"
                                    id="complainNo"
                                    placeholder={t("text.SelectComplainNo")}
                                 />
                              )}
                           />

                        </Grid>


                        <Grid item md={4} sm={4} xs={12}>
                           <TextField
                              label={
                                 <CustomLabel
                                    text={t("text.ComplaintDesc")}
                                    required={false}
                                 />
                              }
                              // type="date"
                              variant="outlined"
                              fullWidth
                              size="small"
                              name="complainName"
                              id="complainName"
                              value={formik.values.complainName}
                              placeholder={t("text.ComplaintDesc")}
                              onChange={formik.handleChange}
                           //InputLabelProps={{ shrink: true }}
                           />

                           {formik.touched.complainName && formik.errors.complainName ? (
                              <div style={{ color: "red", margin: "5px" }}>
                                 {formik.errors.complainName}
                              </div>
                           ) : null}
                        </Grid>




                        {editId !== 0 && (
                           <>
                              <Grid item md={4} sm={4} xs={12}>
                                 <Autocomplete
                                    disablePortal
                                    id="combo-box-demo"
                                    options={IsStatus}
                                    value={IsStatus.find((opt: any) => opt.value === formik.values.statusId) || null}
                                    fullWidth
                                    size="small"
                                    onChange={(event: any, newValue: any) => {
                                       //console.log(newValue);
                                       formik.setFieldValue("statusName", newValue?.label.toString());
                                       formik.setFieldValue("statusId", parseInt(newValue?.value));

                                       if (newValue?.value === 2) {
                                          setShow1(true);
                                       } else if (newValue?.value === 3) {
                                          setShow1(true);
                                       } else {
                                          setShow1(false);
                                       }


                                    }}
                                    renderInput={(params) => (
                                       <TextField
                                          {...params}
                                          label={<CustomLabel text={t("text.ComplainStatus")} required={false} />}

                                       />
                                    )}
                                 />

                              </Grid>


                              <Grid item md={4} sm={4} xs={12}>
                                 <Autocomplete
                                    disablePortal
                                    id="combo-box-demo"
                                    options={ItemSt}
                                    value={ItemSt.find((opt: any) => opt.value === formik.values.itemStatusId) || null} // Ensures correct matching
                                    fullWidth
                                    size="small"
                                    onChange={(event: any, newValue: any) => {
                                       formik.setFieldValue("itemStatus", newValue?.label || "");
                                       formik.setFieldValue("itemStatusId", newValue?.value || null);

                                       if (newValue?.value === 1) {
                                          setShowItem(true);
                                       } else {
                                          setShowItem(false);
                                       }
                                    }}
                                    renderInput={(params) => (
                                       <TextField
                                          {...params}
                                          label={<CustomLabel text={t("text.ItemStatus")} required={false} />}
                                       />
                                    )}
                                 />
                              </Grid>

                           </>
                        )}


                        {showItem && (

                           <Grid item md={4} sm={4} xs={12}>
                              <Autocomplete
                                 disablePortal
                                 id="combo-box-demo"
                                 options={IsItem}
                                 value={IsItem.find((opt: any) => opt.value == formik.values.itemIId) || null}
                                 fullWidth
                                 size="small"
                                 onChange={(event: any, newValue: any) => {
                                    //console.log(newValue);
                                    formik.setFieldValue("itemIName", newValue?.label.toString());
                                    formik.setFieldValue("itemIId", parseInt(newValue?.value));

                                 }}
                                 renderInput={(params) => (
                                    <TextField
                                       {...params}
                                       label={<CustomLabel text={t("text.SelectItem")} required={false} />}

                                    />
                                 )}
                              />

                           </Grid>
                        )}

                        {IsShow1 && (
                           <Grid item md={4} sm={4} xs={12}>
                              <TextField
                                 label={
                                    <CustomLabel
                                       text={t("text.Remark")}
                                       required={false}
                                    />
                                 }
                                 // type="date"
                                 variant="outlined"
                                 fullWidth
                                 size="small"
                                 name="remark"
                                 id="remark"
                                 value={formik.values.remark}
                                 placeholder={t("text.Remark")}
                                 onChange={formik.handleChange}
                              //InputLabelProps={{ shrink: true }}
                              />


                           </Grid>
                        )}


                        <Grid item md={4} sm={4} xs={12}>

                        </Grid>




                        <Grid item lg={6} xs={12}>
                           <FormControl component="fieldset">

                              <Box display="flex" alignItems="center">
                                 <FormLabel component="legend" style={{ marginRight: '30px', fontWeight: "600" }}>
                                    Complain :-
                                 </FormLabel>
                                 <RadioGroup
                                    row
                                    name="complainSource"
                                    value={formik.values.inHouse ? 'inHouse' : 'outSource'}
                                    onChange={(e) => {
                                       const selectedValue = e.target.value;
                                       if (selectedValue === 'inHouse') {
                                          formik.setFieldValue('inHouse', true);
                                          formik.setFieldValue('outSource', false);
                                       } else if (selectedValue === 'outSource') {
                                          formik.setFieldValue('outSource', true);
                                          formik.setFieldValue('inHouse', false);

                                       }
                                    }}
                                 >
                                    <FormControlLabel
                                       value="inHouse"
                                       control={<Radio />}
                                       label="In House"
                                    />
                                    <FormControlLabel
                                       value="outSource"
                                       control={<Radio />}
                                       label="Out Source"
                                    />
                                 </RadioGroup>
                              </Box>
                           </FormControl>
                        </Grid>




                        <Grid item lg={6} xs={12}>
                           <FormControl component="fieldset">

                              <Box display="flex" alignItems="center">
                                 <FormLabel component="legend" style={{ marginRight: '30px', fontWeight: "600" }}>
                                    Employee Type :-
                                 </FormLabel>
                                 <RadioGroup
                                    row
                                    name="employeeType"
                                    value={formik.values.isEmp ? 'isEmp' : 'isRoaster'}
                                    onChange={(e) => {
                                       const selectedValue = e.target.value;
                                       if (selectedValue === 'isEmp') {
                                          formik.setFieldValue('isEmp', true);
                                          formik.setFieldValue('isRoaster', false);
                                       } else if (selectedValue === 'isRoaster') {
                                          formik.setFieldValue('isEmp', false);
                                          formik.setFieldValue('isRoaster', true);
                                       }
                                    }}
                                 >
                                    <FormControlLabel
                                       value="isEmp"
                                       control={<Radio />}
                                       label="Employee"
                                    />
                                    <FormControlLabel
                                       value="isRoaster"
                                       control={<Radio />}
                                       label="Roster Group"
                                    />
                                 </RadioGroup>
                              </Box>
                           </FormControl>
                        </Grid>



                        <Grid item lg={12} md={12} xs={12} marginTop={2}>
                           <ReactQuill
                              id="complaint"
                              theme="snow"
                              value={formik.values.complainName}
                              // onChange={(content) => formik.setFieldValue("complaint", content)}
                              // onBlur={() => formik.setFieldTouched("complaint", true)}
                              modules={modules}
                              formats={formats}
                              //  style={{ backgroundColor: "white", minHeight: "200px" }} 
                              placeholder="Enter your complaint here"
                           />
                        </Grid>





                        <Grid item xs={4} sx={{ m: -1 }}>
                           <ButtonWithLoader
                              buttonText={t("text.save")}
                              onClickHandler={handleSubmitWrapper}
                              fullWidth={true}
                           />
                        </Grid>
                     </Grid>
                  </form>
                  {/* </Grid> */}
                  <Typography
                     variant="h6"
                     component="div"
                     sx={{ flexGrow: 1 }}
                  ></Typography>
                  {/* </Stack> */}
                  {isLoading ? (
                     <div
                        style={{
                           display: "flex",
                           justifyContent: "center",
                           alignItems: "center",
                        }}
                     >
                        <CircularProgress />
                     </div>
                  ) : (
                     <DataGrids
                        isLoading={isLoading}
                        rows={rows}
                        columns={columns}
                        pageSizeOptions={[5, 10, 25, 50, 100]}
                        initialPageSize={5}
                     />
                  )}



                  <Modal open={currentMap} onClose={() => setCurrentMap(false)}>
                     <Box sx={style}>
                        {currentMap && (
                           <Grid item xs={12} sm={12} lg={12}>
                              {/* {isLoading1 ? (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <CircularProgress />
                        </div>
                      ) : ( */}
                              <GoogleMap
                                 mapContainerStyle={containerStyle}
                                 center={center}
                                 zoom={70} // Default zoom, will be adjusted by `fitBounds`
                                 onLoad={(map: any) => (mapRef.current = map)}
                              >
                                 {vehicles.map((vehicle: any) => (
                                    <Marker
                                       key={vehicle.id}
                                       position={{
                                          lat: vehicle.lat,
                                          lng: vehicle.lng,
                                       }}
                                       icon={{
                                          url: vehicle.icon,
                                          scaledSize: new window.google.maps.Size(
                                             50,
                                             50
                                          ),
                                          origin: new window.google.maps.Point(0, 0),
                                          anchor: new window.google.maps.Point(25, 25),
                                       }}
                                       onMouseOver={() =>
                                          handleMarkerMouseOver(vehicle)
                                       } // Show vehicle number on hover
                                       onMouseOut={handleMarkerMouseOut} // Hide info window on hover out
                                    >
                                       {activeVehicle &&
                                          activeVehicle.id === vehicle.id && (
                                             <InfoWindow>
                                                <div>
                                                   <div>
                                                      <strong>Zone Name: </strong>
                                                      {vehicle.zone}
                                                   </div>

                                                   <div>
                                                      <strong>Ward Name: </strong>
                                                      {vehicle.ward}
                                                   </div>

                                                   <div>
                                                      <strong>Employee Name: </strong>
                                                      {vehicle.empName}
                                                   </div>

                                                   <div>
                                                      <strong>Pole No: </strong>
                                                      {vehicle.poleNo}
                                                   </div>

                                                   <div>
                                                      <strong> Assign Date : </strong>
                                                      {vehicle.assignDate}
                                                   </div>
                                                </div>
                                             </InfoWindow>
                                          )}
                                    </Marker>
                                 ))}
                              </GoogleMap>
                              {/* )} */}
                           </Grid>
                        )}
                     </Box>
                  </Modal>

                  <Grid item lg={12} xs={12}>
                     <RosterComponent
                        open={isShow}
                        onClose={() => setShow(false)}
                        rostData={viewData}


                     />

                  </Grid>
               </Paper>
            </Card>
         </Grid >
         <ToastApp />
      </>
   );
}



const modules = {
   toolbar: [
     [{ header: "1" }, { header: "2" }],
     [{ font: [] }],
     [{ size: ["small", false, "large", "huge"] }],
     ["bold", "italic", "underline", "strike"],
     [{ color: [] }, { background: [] }],
     [{ script: "sub" }, { script: "super" }],
     ["blockquote", "code-block"],
     [{ list: "ordered" }, { list: "bullet" }],
     [{ indent: "-1" }, { indent: "+1" }],
     [{ align: [] }],
     ["link", "image", "video", "formula"],
     ["clean"],
   ],
 };
 
 const formats = [
   "header",
   "font",
   "size",
   "bold",
   "italic",
   "underline",
   "strike",
   "color",
   "background",
   "script",
   "list",
   "bullet",
   "indent",
   "align",
   "link",
   "image",
   "video",
   "formula",
   "code-block",
 ];
 